export function spendgoOffercode(clientId, channelId) {
  return ["8c001fde-3728-48dc-9950-b8480ca9fbee",
      "83da098f-2fc7-4b98-8455-c08f9aceb4ed",
      "3fe7e557-16f5-406c-bbc8-887fdec7ba8b",
      "7203dd51-f88b-4a4b-877c-92326d027915",
      "cf6144d2-bb68-43b6-9876-dbf620b57c21"].includes(clientId) &&
      ["3b3e90db-f06b-4ba4-9fbb-769637647ab0",
        "25c7cb9a-a192-46f5-b32d-49e8d52afea8",
        "92ec41c7-6724-4891-bc17-24981a3261dd",
        "c2a842ba-36cc-46b7-8fa4-3a361708b34b",
        "g786cb0f-eecc-4b87-adef-34eb20f3f766",
        "88adbfaa-0fc0-49af-a745-d97cb1b4bda7",
        "1d337d2d-e23a-445a-bda6-2405dbb79dcc",
        "f786cb0f-eecc-4b87-adef-34eb20f3f766",
        "33bc71b1-4495-43f0-ab64-17ed38270e04",
        "3c8a9cf7-a0b2-4845-8436-d598181e6d78"].includes(channelId)
}


// WEBPACK FOOTER //
// ./src/util/client-specific/spendgo-offercode.js